export default function FooterSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer aria-label="フッター" className="bg-amber-900 text-white py-14">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 mb-10">
          {/* Brand */}
          <div className="md:w-1/3">
            <img
              src="https://public.readdy.ai/ai/img_res/58da60f9-74f3-471a-bb7f-e3e73c5a08d9.png"
              alt="家の管理おまかせパック"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-amber-200 text-sm leading-relaxed mb-4">
              岡山県南部で創業15年。地域の皆さまの大切な家を、ワンストップでお守りします。
            </p>
            <div className="flex gap-3">
              {['ri-line-fill', 'ri-instagram-line', 'ri-facebook-circle-line'].map((icon) => (
                <a key={icon} href="#" className="w-9 h-9 flex items-center justify-center bg-amber-800 hover:bg-amber-700 rounded-full transition-colors cursor-pointer">
                  <i className={`${icon} text-white text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-col sm:flex-row gap-8 flex-1">
            <div>
              <h4 className="text-amber-300 text-xs font-bold tracking-widest mb-3 uppercase">サービス</h4>
              <ul className="space-y-2">
                {[
                  { label: 'サービス内容', id: 'merit' },
                  { label: '報告システム', id: 'report' },
                  { label: '料金プラン', id: 'price' },
                  { label: 'キャンペーン', id: 'campaign' },
                ].map((item) => (
                  <li key={item.id}>
                    <button onClick={() => scrollTo(item.id)} className="cursor-pointer text-amber-100 hover:text-white text-sm transition-colors whitespace-nowrap">
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-amber-300 text-xs font-bold tracking-widest mb-3 uppercase">お問い合わせ</h4>
              <ul className="space-y-2 text-sm text-amber-100">
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-amber-400"></i>
                  <a href="tel:0120847481" className="hover:text-white transition-colors cursor-pointer">
                    0120-847-481
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-amber-400"></i>
                  <span>受付 9:00〜18:00（年中無休）</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-amber-400"></i>
                  <span>岡山県岡山市南区</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-amber-800 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-amber-300 text-xs">© 2024 家の管理おまかせパック. All rights reserved.</p>
          <div className="flex gap-4 text-xs text-amber-300">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">特定商取引法</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
